import { gql } from 'application/providers/DataProvider';

export const POINT_SET_CURRENT_IN_ONBOARDING_QUERY = gql`
  query pointSetCurrentInOnboarding @client {
    currentPoint
  }
`;
